import { useState } from 'react'
import { SansText } from '@velasca/ui/sans-text'
import { SerifTitle } from '@velasca/ui/serif-title'
import {
  PolicyTextContainer,
  StyledInlineInput,
  TextWrapper,
  Wrapper,
} from './NewsletterForm.styles'
import type { InsertEmailProps } from './NewsletterForm.types'

export const NewsletterForm = ({
  title,
  description,
  placeholder,
  privacyPolicyText,
  errorMessage,
  subscribe,
  status,
}: InsertEmailProps): JSX.Element => {
  const [email, setEmail] = useState('')

  return (
    <Wrapper>
      <SerifTitle as="h2" size="lg">
        {title}
      </SerifTitle>

      <TextWrapper>
        <SansText
          as="div"
          size="md"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </TextWrapper>

      <form
        onSubmit={(e) => {
          e.preventDefault()
          subscribe(email)
        }}
      >
        <StyledInlineInput
          required
          error={status === 'error'}
          loading={status === 'loading'}
          placeholder={placeholder}
          type="email"
          name="email"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value)
          }}
        />
      </form>

      {status === 'error' && (
        <SansText center size="sm" color="error">
          {errorMessage}
        </SansText>
      )}

      <PolicyTextContainer>
        <SansText
          as="div"
          dangerouslySetInnerHTML={{ __html: privacyPolicyText }}
        />
      </PolicyTextContainer>
    </Wrapper>
  )
}
